import { z } from 'zod';
import { WithId } from './WithId';
import { Dentition, DentitionSchema, Sex, SexSchema } from '@/schema/enums';

import { Status } from '@/schema/jawsScan';

export const PatientCreateSchema = z.object({
  firstName: z.string(),
  middleName: z.string().nullable().optional(),
  lastName: z.string(),
  dateOfBirth: z.string().date(),
  dentition: DentitionSchema,
  sex: SexSchema.optional(),
  clinicId: z.string().nonempty('Clinic ID is required'),
  orthodontistId: z.string().nonempty('Clinic ID is required'),
  phone: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  address: z.string().nullable().optional(),
});

export type PatientCreate = z.infer<typeof PatientCreateSchema>;

export type PatientUpdate = z.infer<typeof PatientCreateSchema>;

export type PatientResponse = WithId & {
  orthodontistId: string;
  orthodontistName: string;
  clinicId: string;
  clinicName: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  dateOfBirth: string;
  dentition: Dentition;
  address?: string | null;
  phone?: string | null;
  email?: string | null;
  sex?: Sex | null;
  latestScanStatus: Status;
};

export const PatientSearchSchema = z.object({
  search: z.string().optional(),
});

export type PatientFilter = {
  status: Status | undefined;
  scanDateFrom: Date | undefined;
  scanDateTo: Date | undefined;
  clinicId: string | undefined;
};

export type PatientQuery = PatientFilter & {
  search: string | undefined;
};
